import type { ThreadActionSelection } from "@afar-research/contracts";

/**
 * What attaching files or folders does, decided before they land in the
 * composer (ADR 0142). Any thread can feed the Brain, so an attach without an
 * Ingest chip asks whether the material is for the Brain or only for this
 * message — unless the project always ingests attachments.
 */
export type AttachIngestDecision =
  /** Attach as an ordinary message attachment. */
  | "attach"
  /** Ask "Ingest into Brain" or "Just attach". */
  | "ask"
  /** Set the Ingest chip and collect the material as its sources. */
  | "ingest";

export function decideAttachIngest(input: {
  /** The Action chip the composer already holds, if any. */
  readonly action: ThreadActionSelection | null;
  /** The project's `alwaysIngestAttachments` setting. */
  readonly alwaysIngest: boolean;
  /** Only files and folders ask; images pasted as pictures and text pastes do not. */
  readonly attachesFilesOrFolders: boolean;
}): AttachIngestDecision {
  // Ingest already collects sources; other chips still offer the Brain choice.
  if (input.action?.id === "ingest" || !input.attachesFilesOrFolders) return "attach";
  return input.alwaysIngest ? "ingest" : "ask";
}

/** The chip an ingest choice sets. */
export const INGEST_ACTION_SELECTION: ThreadActionSelection = { id: "ingest" };
